var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMeta = function SvgMeta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3531 5C14.7131 5 13.432 6.3006 12.2704 7.954C10.6757 5.8148 9.34268 5 7.74656 5C4.49319 5 2 9.4604 2 14.1826C2 17.1366 3.3569 19 5.62948 19C7.26547 19 8.44162 18.188 10.5335 14.3366C10.5335 14.3366 11.4053 12.7154 12.0047 11.5982C12.2146 11.9552 12.4366 12.3402 12.6691 12.7532L13.6499 14.4906C15.5597 17.8576 16.6242 19 18.5539 19C20.768 19 22 17.1114 22 14.0958C21.9987 9.1524 19.4497 5 16.3531 5ZM8.93867 13.2936C7.24287 16.0936 6.65679 16.7208 5.71187 16.7208C4.74038 16.7208 4.16227 15.822 4.16227 14.2204C4.16227 10.7932 5.78497 7.2876 7.71865 7.2876C8.7659 7.2876 9.6417 7.9246 10.9813 9.9462C9.70948 12.0042 8.93867 13.2936 8.93867 13.2936ZM15.3378 12.9408L14.1656 10.8814C13.848 10.3382 13.5436 9.837 13.2512 9.3806C14.3065 7.6614 15.1783 6.806 16.2162 6.806C18.3705 6.806 20.0929 10.1464 20.0929 14.2498C20.0929 15.8136 19.6065 16.7222 18.5991 16.7222C17.6329 16.7208 17.1718 16.0488 15.3378 12.9408Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMeta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meta.13d15d83.svg";
export { ForwardRef as ReactComponent };